// extracted by mini-css-extract-plugin
export var header = "_h2-0";